function WordTestResultArea(props: any) {
  let myProps = {
    Style: {},
    todo_info: null,
    word_pre_info: null,
    word_data_arr: [],
    ...props
  };
  let { Style, todo_info, word_pre_info, word_data_arr } = myProps;
  let total_result_data = {
    correct_cnt: 0,
    total_cnt: word_data_arr.length,
  };
  let stu_word_det_arr: any = [];
  if (word_pre_info && word_pre_info.stu_word_det_info_arr) {
    for (let i = 0; i < word_pre_info.stu_word_det_info_arr.length; i++) {
      let row_det = word_pre_info.stu_word_det_info_arr[i];
      if (row_det.a_cont_sort_det == "white_paper_test") {
        stu_word_det_arr.push(row_det);
        if (row_det.a_correct_cnt) {
          total_result_data.correct_cnt += 1;
        }
      }
    }
  }

  const get_word_result_tags = () => {
    let result_tags: any = word_data_arr.map((word_data: any, idx: number) => {
      let stu_word_det: any = null;
      let word_str = word_data.e_script;
      let word_key = word_str.toLowerCase();
      for (let i = 0; i < stu_word_det_arr.length; i++) {
        let row_det = stu_word_det_arr[i];
        if (row_det.a_word == word_key) {
          stu_word_det = row_det;
          break;
        }
      }

      let input_word_str = "";
      if (stu_word_det) {
        input_word_str = stu_word_det.a_input_test_arr;
      }

      let row_is_correct = false;
      if (stu_word_det && stu_word_det.a_correct_cnt) {
        row_is_correct = true;
      }

      let time_str = "";
      if (stu_word_det && stu_word_det.a_elapse_time_sec) {
        time_str = stu_word_det.a_elapse_time_sec;
      }

      return (
        <tr key={idx}>
          <td className={Style.word_cell}>{word_data.e_script}</td>
          <td className={Style.input_cell}>{input_word_str}</td>
          <td className={row_is_correct ? Style.result_correct : Style.result_wrong}>
            {row_is_correct == true ? "O" : "X"}
          </td>
          <td className={Style.time_cell}>
            {time_str}
          </td>
          <td>
            {word_data.k_script}
          </td>
        </tr>
      );
    });

    return result_tags;
  };

  return (
    <div className={Style.word_result_wrap}>
      <table className={Style.word_result_table}>
        <colgroup>
          <col width="25%"></col>
          <col width="25%"></col>
          <col width="10%"></col>
          <col width="10%"></col>
          <col width="30%"></col>
        </colgroup>
        <thead>
          <tr>
            <th>단어</th>
            <th>입력</th>
            <th>OX</th>
            <th>시간</th>
            <th>뜻</th>
          </tr>
        </thead>
        <tbody>
          {get_word_result_tags()}
        </tbody>
      </table>
    </div>
  );
};
export default WordTestResultArea;